import { LoadingButton } from "@mui/lab";
import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export type CustomDialogProps = {
  onClose?: () => void;
  onSubmit?: () => void;
  open: boolean;
  loading?: boolean;
  children?: React.ReactNode;
  title?: string;
  submitLabel?: string;
  cancelLabel?: string;
  fullScreen?: boolean;
  buttons?: {
    label: string;
    onClick: () => void;
    loadingButton?: boolean;
    variant?: "text" | "outlined" | "contained" | undefined;
  }[];
};

export const FormDialog = ({
  onSubmit,
  submitLabel,
  onClose,
  cancelLabel,
  open,
  children,
  title,
  fullScreen,
  buttons,
  loading,
}: CustomDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      fullScreen={fullScreen}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit && onSubmit();
        }}
        noValidate
      >
        <DialogTitle id="form-dialog-title">{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          {buttons &&
            buttons?.map((button) => (
              <>
                {button.loadingButton && (
                  <LoadingButton
                    key={button.label}
                    onClick={button.onClick}
                    disabled={loading}
                    loading={loading}
                    variant={button.variant}
                  >
                    {button.label}
                  </LoadingButton>
                )}
                {!button.loadingButton && (
                  <Button
                    key={button.label}
                    onClick={button.onClick}
                    disabled={loading}
                    variant={button.variant}
                  >
                    {button.label}
                  </Button>
                )}
              </>
            ))}
          {!buttons && onClose && (
            <Button onClick={onClose}>{cancelLabel || "Cancel"}</Button>
          )}
          {!buttons && onSubmit && (
            <LoadingButton loading={loading} type="submit" variant="contained">
              {submitLabel || "Submit"}
            </LoadingButton>
          )}
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default FormDialog;
